import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'hooks/apollo';
import { Tooltip } from '@mui/material';
import { buildSecurityExportDownloadUrl } from '../../../api';
import { EXPORT_SECURITY_LIST } from '../../../mutations';
import { CloudDownload } from '@mui/icons-material';
import { fileType } from 'constants/fileTypes';
import { useSimpleError } from 'hooks/apolloWrappers';
import Menu from '@mui/material/Menu';
import { convertBase64ToFile } from 'utils/base64FileConversion';
import saveAs from 'file-saver';
import { MenuItemWithAction } from 'components/menu/MenuWithActionsStyle';
import { IconButton } from '@totalsoft/rocket-ui';
import { getOidcConfigName } from 'utils/functions';
import { useOidcAccessToken } from '@axa-fr/react-oidc';

const ExportAction = ({ saving, setSaving }) => {
  const [t] = useTranslation();
  const showError = useSimpleError();
  const { accessToken } = useOidcAccessToken(getOidcConfigName());

  const [exportAnchorEl, setShowHandleClose] = useState(null);
  const isExportOpen = Boolean(exportAnchorEl);

  const [exportSecurityList] = useMutation(EXPORT_SECURITY_LIST, {
    onCompleted: async ({ exportSecurityList }) => {
      let downloadLink = null;
      try {
        if (exportSecurityList.fileBytes) {
          saveAs(convertBase64ToFile(exportSecurityList.fileBytes), exportSecurityList.fileName);
          setSaving(false);
          return;
        }
        downloadLink = await buildSecurityExportDownloadUrl(exportSecurityList.filePath, exportSecurityList.fileName, accessToken);
        if (downloadLink) {
          window.location.href = downloadLink;
        }
        setSaving(false);
      } catch (error) {
        setSaving(false);
        showError(error);
      }
    }
  });

  const onExport = fileType => {
    exportSecurityList({ variables: { fileType: fileType } });
  };

  const handleExportClose = () => {
    setShowHandleClose(null);
  };

  const handleExportClick = event => {
    setShowHandleClose(event.currentTarget);
  };

  const handleExport = fileType => () => {
    setSaving(true);
    onExport(fileType);
    setShowHandleClose(null);
  };

  return (
    <Tooltip placement='top' title={t('Authorization.Export')}>
      <div>
        <IconButton color='primary' onClick={handleExportClick} disabled={saving}>
          <CloudDownload />
        </IconButton>
        <Menu id='render-export-menu' anchorEl={exportAnchorEl} open={isExportOpen} onClose={handleExportClose}>
          <MenuItemWithAction onClick={handleExport(fileType.excel)}>{t('Authorization.Excel')}</MenuItemWithAction>
          <MenuItemWithAction onClick={handleExport(fileType.csv)}>{t('Authorization.CSV')}</MenuItemWithAction>
        </Menu>
      </div>
    </Tooltip>
  );
};
ExportAction.propTypes = {
  saving: PropTypes.bool.isRequired,
  setSaving: PropTypes.func.isRequired
};
export default ExportAction;
